import {create} from 'zustand'

export interface FormState {
    id:string;
    password:string;
    passwordConfirm:string;
    name:string;
    contact:string;
    email:string;
}

export const useSignFormStore = create<FormState & { setField: (field: keyof FormState, value: string) => void } & {reset: ()=>void}>((set)=>({
    id:'',
    password:'',
    passwordConfirm:'',
    name:'',
    contact:'',
    email:'',
    setField: (field,value)=>set((state)=>({...state,[field]:value})),
    reset: () =>
        set(() => ({
          id: '',
          password: '',
          passwordConfirm: '',
          name: '',
          contact: '',
          email: '',
        })),
}))